<template>
    <div>
        <div class="form-group">
            <label>Authentication URL</label>
            <input type="text" class="form-control" v-model="data.authenticationUrl">
        </div>
        <div class="form-group">
            <label>Client ID</label>
            <input type="text" class="form-control" v-model="data.clientId">
        </div>
        <div class="form-group">
            <label>Client Secret</label>
            <input type="text" class="form-control" v-model="data.clientSecret">
        </div>
        <div class="form-group">
            <label>Username</label>
            <input type="text" class="form-control" v-model="data.username">
        </div>
        <div class="form-group">
            <label>Password</label>
            <input type="text" class="form-control" v-model="data.password">
        </div>
        <div class="form-group">
            <label>Security Token</label>
            <input type="text" class="form-control" v-model="data.securityToken">
        </div>
        <div class="form-group">
            <label>Leads URL Path</label>
            <input type="text" class="form-control" v-model="data.leadsUrlPath">
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: [
        'data'
    ],
    data() {
        return {
        };
    }
}
</script>
